import { useState, useEffect, useContext } from "react";
import { AuthContext } from "components/Context/AuthContext";
import Header1 from "./Header1"
import Header2 from "./Header2"

const Navbar = () => {
    const [fullMenu, setFullMenu] = useState(true);
    const { isAuthenticated, logout } = useContext(AuthContext);

    useEffect(() => {
        const storedValue = sessionStorage.getItem("sFullMenu");
        if (storedValue) {
            setFullMenu(storedValue);
        }
    }, []);
  
    const toggHeader = () => {
      setFullMenu((value) => !value)
      sessionStorage.setItem("sFullMenu", fullMenu);
    };

    return (
        <div>
            {fullMenu ? (
                <Header2 onMenuClick={toggHeader} isAuthenticated={isAuthenticated}/>
            ) : (
                <Header1 onMenuClick={toggHeader} isAuthenticated={isAuthenticated}/>
            )}
        </div>
    );  
}

export default Navbar